import React, { Component, useContext } from 'react'
import Pills from '@app/components/ui/controls/Pills'
import PropTypes from 'prop-types'
import { Parent } from '@app/models/users'

import { AbilityContext } from '@app/context/ability-context'
import { parentTabs } from '@app/helpers/menusHelper'

const PillsMenu = ({ teacher, route }) => {
  const ability = useContext(AbilityContext);

  return (
    <div className="submenu">
      <Pills
        items={parentTabs(ability, route)}
        route={route}
      />
    </div>
  )
}

PillsMenu.propTypes = {
  parent: PropTypes.instanceOf(Parent).isRequired,
  route: PropTypes.object.isRequired
}

export default PillsMenu
